import { Fraction } from 'bi-fraction';
import { solidityPacked, } from 'ethers';
import { PoolType } from '../types/base';
export class SwapServiceAbstract {
    constructor(spender, addressThis, gasRefundContract) {
        this.spender = spender;
        this.addressThis = addressThis;
        this.gasRefundContract = gasRefundContract;
        this.getCalldatasOfSwap_exactInput = (trade, opts, recipient) => {
            const routerMustCustody = this.isRouterMustCustody(trade, opts);
            const splittedPaths = splitRoutes({
                routes: trade.routes,
                slippageTolerance: opts.slippageTolerance,
                routerMustCustody,
                addressThis: this.addressThis,
                recipient,
            });
            const calldatas = splittedPaths.map((path) => {
                const isV3 = path.version !== PoolType.V2;
                if (isV3) {
                    return this.encodeFunctionData_v3_exactInput(path.amountIn, path.amountOutMinimum, solidityPacked(path.v3Path.types, path.v3Path.values), path.recipient);
                }
                return this.encodeFunctionData_v2_swapExactTokensForTokens(path.amountIn, path.amountOutMinimum, path.v2Path, path.recipient);
            });
            // unwrap or sweep
            if (routerMustCustody) {
                if (this.isNativeToken(opts.to)) {
                    // TODO
                    // calldatas.push(PaymentsExtended.encodeUnwrapWETH9(minAmountOut.quotient, options.recipient, options.fee));
                }
                else {
                    // sweepToken
                    calldatas.push(this.encodeFunctionData_sweepToken({
                        ...trade.amountOut,
                        amount: new Fraction(trade.amountOut.amount)
                            .mul(1 - opts.slippageTolerance)
                            .toFixed(0),
                    }, recipient));
                }
            }
            return {
                calldatas,
                splittedPaths,
                value: this.isNativeToken(opts.from) ? opts.amount : undefined,
            };
        };
        this.swap_exactInput = (trade, opts, recipient, signer) => {
            const { calldatas, value } = this.getCalldatasOfSwap_exactInput(trade, opts, recipient);
            return this.multicall(signer, calldatas, value);
        };
        this.swap_exactInput_estimateGas = async (trade, opts, recipient, signer) => {
            const { calldatas, value } = await this.getCalldatasOfSwap_exactInput(trade, opts, recipient);
            return this.estimateGasOfMulticall(signer, calldatas, value);
        };
        this.isApproveNeeded = async (account, amount) => {
            if (this.isNativeToken(amount))
                return false;
            const allowance = await this.allowance(account, this.spender, amount);
            return new Fraction(allowance).lt(amount.amount);
        };
        this.approve = async (amount, signer) => {
            if (this.isNativeToken(amount))
                return;
            return (await this._approve(this.spender, amount, signer)).wait();
        };
    }
}
const splitRoutes = ({ routes, slippageTolerance, routerMustCustody, addressThis, recipient, }) => {
    // By default router holds funds until the last swap, then it is sent to the recipient
    // special case exists where we are unwrapping WETH output, in which case `routerMustCustody` is set to true
    // and router still holds the funds. That logic bundled into how the value of `recipient` is calculated
    recipient = routerMustCustody ? addressThis : recipient;
    const paths = [];
    routes.forEach((r) => {
        const curPaths = [];
        r.pool.forEach((p, i) => {
            const amountIn = i === 0 ? r.amountIn.amount : '0';
            const amountOutMinimum = i === r.pool.length - 1
                ? new Fraction(r.amountOut.amount)
                    .mul(1 - slippageTolerance)
                    .toFixed(0)
                : '0';
            if (!curPaths.length ||
                p.version !== curPaths[curPaths.length - 1].version) {
                curPaths.push({
                    version: p.version,
                    amountIn,
                    amountOutMinimum,
                    v2Path: [p.tokenIn.address],
                    v3Path: {
                        types: ['address'],
                        values: [p.tokenIn.address],
                    },
                });
            }
            curPaths[curPaths.length - 1].v2Path.push(p.tokenOut.address);
            curPaths[curPaths.length - 1].v3Path.types.push('uint24', 'address');
            curPaths[curPaths.length - 1].v3Path.values.push(p.version === PoolType.V2 ? 8388608 : +p.version.slice(3), p.tokenOut.address);
        });
        // if there is any mix path route, the final path`s recipient is the recipient, before that contract will hold the funds
        paths.push(...curPaths.map((paths, i) => ({
            ...paths,
            recipient: i === curPaths.length - 1 ? recipient : addressThis,
        })));
    });
    return paths;
};
